import React from "react";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { ActiveParagraphColor, ButtonCommonTopNew } from "../../pages/Theme";
import ReviewTabIcon from '../../common/images-new/review-tab-icon.svg';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { BsStars } from "react-icons/bs";

const FeedbackHistory = ({ text, color, onClick, style }) => {
    const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);
    return (
        <ButtonCommonTopNew
            className={`flex flex-row  rounded-md px-3 py-2 
                        items-center justify-center w-flex ${style}`}
            onClick={onClick}
        >
            {/* <img src={ReviewTabIcon} alt="Review Icon" className={`bg-${color}-light`} /> */}
            <BsStars style={{ fontSize: '16px' }} className=' blueColor mr-1' />
            {/* <FileDownloadOutlinedIcon sx={{ color: '#2084D4' }} /> */}
            <p className={` font-regular text-xs lg:text-sm`}>{text}</p>
        </ButtonCommonTopNew>
    )
}

FeedbackHistory.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    url: PropTypes.string,
}

export default FeedbackHistory;
